import './App.css';
import Inicio from 'pages/Inicio';

function App() {
  return (
    <div className="App">
      <Inicio/>
    </div>
  );
}

export default App;
